var _typeof = require("@babel/runtime/helpers/typeof");

(function () {
  var g,
      goog = goog || {},
      k = this;

  function l(a) {
    return "string" == typeof a;
  }

  function n(a, b) {
    a = a.split(".");
    b = b || k;

    for (var c = 0; c < a.length; c++) {
      if (b = b[a[c]], null == b) return null;
    }

    return b;
  }

  function aa() {}

  function ba(a) {
    var b = _typeof(a);

    if ("object" == b) {
      if (a) {
        if (a instanceof Array) return "array";
        if (a instanceof Object) return b;
        var c = Object.prototype.toString.call(a);
        if ("[object Window]" == c) return "object";
        if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";
        if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function";
      } else return "null";
    } else if ("function" == b && "undefined" == typeof a.call) return "object";
    return b;
  }

  function p(a) {
    return "array" == ba(a);
  }

  function ca(a) {
    var b = ba(a);
    return "array" == b || "object" == b && "number" == typeof a.length;
  }

  function da(a) {
    return "function" == ba(a);
  }

  function ea(a) {
    var b = _typeof(a);

    return "object" == b && null != a || "function" == b;
  }

  var q = "closure_uid_" + (1E9 * Math.random() >>> 0),
      fa = 0;

  function ha(a, b, c) {
    return a.call.apply(a.bind, arguments);
  }

  function ia(a, b, c) {
    if (!a) throw Error();

    if (2 < arguments.length) {
      var d = Array.prototype.slice.call(arguments, 2);
      return function () {
        var c = Array.prototype.slice.call(arguments);
        Array.prototype.unshift.apply(c, d);
        return a.apply(b, c);
      };
    }

    return function () {
      return a.apply(b, arguments);
    };
  }

  function r(a, b, c) {
    Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? r = ha : r = ia;
    return r.apply(null, arguments);
  }

  function ja(a, b) {
    var c = Array.prototype.slice.call(arguments, 1);
    return function () {
      var b = c.slice();
      b.push.apply(b, arguments);
      return a.apply(this, b);
    };
  }

  var t = Date.now || function () {
    return +new Date();
  };

  function u(a, b) {
    function c() {}

    c.prototype = b.prototype;
    a.H = b.prototype;
    a.prototype = new c();
    a.prototype.constructor = a;

    a.Ib = function (a, c, f) {
      for (var d = Array(arguments.length - 2), e = 2; e < arguments.length; e++) {
        d[e - 2] = arguments[e];
      }

      return b.prototype[c].apply(a, d);
    };
  }

  ;

  function ka(a) {
    if (Error.captureStackTrace) Error.captureStackTrace(this, ka);else {
      var b = Error().stack;
      b && (this.stack = b);
    }
    a && (this.message = String(a));
  }

  u(ka, Error);
  ka.prototype.name = "CustomError";

  function la(a, b) {
    a = a.split("%s");

    for (var c = "", d = a.length - 1, e = 0; e < d; e++) {
      c += a[e] + (e < b.length ? b[e] : "%s");
    }

    ka.call(this, c + a[d]);
  }

  u(la, ka);
  la.prototype.name = "AssertionError";

  function ma(a, b) {
    throw new la("Failure" + (a ? ": " + a : ""), Array.prototype.slice.call(arguments, 1));
  }

  ;

  function w() {
    0 != na && (pa[this[q] || (this[q] = ++fa)] = this);
    this.i = this.i;
    this.m = this.m;
  }

  var na = 0,
      pa = {};
  w.prototype.i = !1;

  w.prototype.$ = function () {
    if (!this.i && (this.i = !0, this.w(), 0 != na)) {
      var a = this[q] || (this[q] = ++fa);
      if (0 != na && this.m && 0 < this.m.length) throw Error(this + " did not empty its onDisposeCallbacks queue. This probably means it overrode dispose() or disposeInternal() without calling the superclass' method.");
      delete pa[a];
    }
  };

  w.prototype.w = function () {
    if (this.m) for (; this.m.length;) {
      this.m.shift()();
    }
  };

  var qa = Array.prototype.indexOf ? function (a, b) {
    return Array.prototype.indexOf.call(a, b, void 0);
  } : function (a, b) {
    if (l(a)) return l(b) && 1 == b.length ? a.indexOf(b, 0) : -1;

    for (var c = 0; c < a.length; c++) {
      if (c in a && a[c] === b) return c;
    }

    return -1;
  },
      ra = Array.prototype.forEach ? function (a, b, c) {
    Array.prototype.forEach.call(a, b, c);
  } : function (a, b, c) {
    for (var d = a.length, e = l(a) ? a.split("") : a, f = 0; f < d; f++) {
      f in e && b.call(c, e[f], f, a);
    }
  };

  function sa(a) {
    a: {
      var b = ta;

      for (var c = a.length, d = l(a) ? a.split("") : a, e = 0; e < c; e++) {
        if (e in d && b.call(void 0, d[e], e, a)) {
          b = e;
          break a;
        }
      }

      b = -1;
    }

    return 0 > b ? null : l(a) ? a.charAt(b) : a[b];
  }

  function ua(a) {
    if (!p(a)) for (var b = a.length - 1; 0 <= b; b--) {
      delete a[b];
    }
    a.length = 0;
  }

  function va(a) {
    return Array.prototype.concat.apply([], arguments);
  }

  function wa(a) {
    var b = a.length;

    if (0 < b) {
      for (var c = Array(b), d = 0; d < b; d++) {
        c[d] = a[d];
      }

      return c;
    }

    return [];
  }

  ;

  function xa(a) {
    return /^[\s\xa0]*$/.test(a);
  }

  var ya = String.prototype.trim ? function (a) {
    return a.trim();
  } : function (a) {
    return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1];
  };

  function za(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
  }

  ;
  var x;

  a: {
    var Aa = k.navigator;

    if (Aa) {
      var Ba = Aa.userAgent;

      if (Ba) {
        x = Ba;
        break a;
      }
    }

    x = "";
  }

  function y(a) {
    return -1 != x.indexOf(a);
  }

  ;

  function Ca(a, b, c) {
    for (var d in a) {
      b.call(c, a[d], d, a);
    }
  }

  function Da(a) {
    var b = [],
        c = 0,
        d;

    for (d in a) {
      b[c++] = a[d];
    }

    return b;
  }

  function Ea(a) {
    var b = [],
        c = 0,
        d;

    for (d in a) {
      b[c++] = d;
    }

    return b;
  }

  function Fa(a) {
    var b = {},
        c;

    for (c in a) {
      b[c] = a[c];
    }

    return b;
  }

  var Ga = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");

  function Ha(a, b) {
    for (var c, d, e = 1; e < arguments.length; e++) {
      d = arguments[e];

      for (c in d) {
        a[c] = d[c];
      }

      for (var f = 0; f < Ga.length; f++) {
        c = Ga[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
      }
    }
  }

  ;

  function Ia(a) {
    Ia[" "](a);
    return a;
  }

  Ia[" "] = aa;

  function Ja(a, b) {
    var c = Ka;
    return Object.prototype.hasOwnProperty.call(c, a) ? c[a] : c[a] = b(a);
  }

  ;
  var La = y("Opera"),
      z = y("Trident") || y("MSIE"),
      Ma = y("Edge"),
      Na = Ma || z,
      Oa = y("Gecko") && !(-1 != x.toLowerCase().indexOf("webkit") && !y("Edge")) && !(y("Trident") || y("MSIE")) && !y("Edge"),
      Pa = -1 != x.toLowerCase().indexOf("webkit") && !y("Edge");

  function Qa() {
    var a = k.document;
    return a ? a.documentMode : void 0;
  }

  var Ra;

  a: {
    var Sa = "",
        Ta = function () {
      var a = x;
      if (Oa) return /rv:([^\);]+)(\)|;)/.exec(a);
      if (Ma) return /Edge\/([\d\.]+)/.exec(a);
      if (z) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);
      if (Pa) return /WebKit\/(\S+)/.exec(a);
      if (La) return /(?:Version)[ \/]?(\S+)/.exec(a);
    }();

    Ta && (Sa = Ta ? Ta[1] : "");

    if (z) {
      var Ua = Qa();

      if (null != Ua && Ua > parseFloat(Sa)) {
        Ra = String(Ua);
        break a;
      }
    }

    Ra = Sa;
  }

  var Ka = {};

  function Va(a) {
    return Ja(a, function () {
      for (var b = 0, c = ya(String(Ra)).split("."), d = ya(String(a)).split("."), e = Math.max(c.length, d.length), f = 0; 0 == b && f < e; f++) {
        var h = c[f] || "",
            m = d[f] || "";

        do {
          h = /(\d*)(\D*)(.*)/.exec(h) || ["", "", "", ""];
          m = /(\d*)(\D*)(.*)/.exec(m) || ["", "", "", ""];
          if (0 == h[0].length && 0 == m[0].length) break;
          b = za(0 == h[1].length ? 0 : parseInt(h[1], 10), 0 == m[1].length ? 0 : parseInt(m[1], 10)) || za(0 == h[2].length, 0 == m[2].length) || za(h[2], m[2]);
          h = h[3];
          m = m[3];
        } while (0 == b);
      }

      return 0 <= b;
    });
  }

  var Wa;
  var Xa = k.document;
  Wa = Xa && z ? Qa() || ("CSS1Compat" == Xa.compatMode ? parseInt(Ra, 10) : 5) : void 0;

  var Ya = Object.freeze || function (a) {
    return a;
  };

  var Za = !z || 9 <= Number(Wa),
      $a = z && !Va("9"),
      ab = function () {
    if (!k.addEventListener || !Object.defineProperty) return !1;
    var a = !1,
        b = Object.defineProperty({}, "passive", {
      get: function get() {
        a = !0;
      }
    });
    k.addEventListener("test", aa, b);
    k.removeEventListener("test", aa, b);
    return a;
  }();

  function A(a, b) {
    this.type = a;
    this.a = this.target = b;
    this.Ra = !0;
  }

  A.prototype.b = function () {
    this.Ra = !1;
  };

  function bb(a, b) {
    A.call(this, a ? a.type : "");
    this.relatedTarget = this.a = this.target = null;
    this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
    this.key = "";
    this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
    this.pointerId = 0;
    this.pointerType = "";
    this.c = null;

    if (a) {
      var c = this.type = a.type,
          d = a.changedTouches ? a.changedTouches[0] : null;
      this.target = a.target || a.srcElement;
      this.a = b;

      if (b = a.relatedTarget) {
        if (Oa) {
          a: {
            try {
              Ia(b.nodeName);
              var e = !0;
              break a;
            } catch (f) {}

            e = !1;
          }

          e || (b = null);
        }
      } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);

      this.relatedTarget = b;
      null === d ? (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0) : (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0);
      this.button = a.button;
      this.key = a.key || "";
      this.ctrlKey = a.ctrlKey;
      this.altKey = a.altKey;
      this.shiftKey = a.shiftKey;
      this.metaKey = a.metaKey;
      this.pointerId = a.pointerId || 0;
      this.pointerType = l(a.pointerType) ? a.pointerType : cb[a.pointerType] || "";
      this.c = a;
      a.defaultPrevented && this.b();
    }
  }

  u(bb, A);
  var cb = Ya({
    2: "touch",
    3: "pen",
    4: "mouse"
  });

  bb.prototype.b = function () {
    bb.H.b.call(this);
    var a = this.c;
    if (a.preventDefault) a.preventDefault();else if (a.returnValue = !1, $a) try {
      if (a.ctrlKey || 112 <= a.keyCode && 123 >= a.keyCode) a.keyCode = -1;
    } catch (b) {}
  };

  var db = "closure_listenable_" + (1E6 * Math.random() | 0),
      eb = 0;

  function fb(a, b, c, d, e) {
    this.listener = a;
    this.proxy = null;
    this.src = b;
    this.type = c;
    this.capture = !!d;
    this.ga = e;
    this.key = ++eb;
    this.Z = this.ba = !1;
  }

  function gb(a) {
    a.Z = !0;
    a.listener = null;
    a.proxy = null;
    a.src = null;
    a.ga = null;
  }

  ;

  function hb(a) {
    this.src = a;
    this.a = {};
    this.b = 0;
  }

  hb.prototype.add = function (a, b, c, d, e) {
    var f = a.toString();
    a = this.a[f];
    a || (a = this.a[f] = [], this.b++);
    var h = ib(a, b, d, e);
    -1 < h ? (b = a[h], c || (b.ba = !1)) : (b = new fb(b, this.src, f, !!d, e), b.ba = c, a.push(b));
    return b;
  };

  function jb(a, b) {
    var c = b.type;

    if (c in a.a) {
      var d = a.a[c],
          e = qa(d, b),
          f;
      (f = 0 <= e) && Array.prototype.splice.call(d, e, 1);
      f && (gb(b), 0 == a.a[c].length && (delete a.a[c], a.b--));
    }
  }

  function ib(a, b, c, d) {
    for (var e = 0; e < a.length; ++e) {
      var f = a[e];
      if (!f.Z && f.listener == b && f.capture == !!c && f.ga == d) return e;
    }

    return -1;
  }

  ;
  var kb = "closure_lm_" + (1E6 * Math.random() | 0),
      lb = {},
      mb = 0;

  function nb(a, b, c, d, e) {
    if (d && d.once) return ob(a, b, c, d, e);

    if (p(b)) {
      for (var f = 0; f < b.length; f++) {
        nb(a, b[f], c, d, e);
      }

      return null;
    }

    c = pb(c);
    return a && a[db] ? a.Ia(b, c, ea(d) ? !!d.capture : !!d, e) : qb(a, b, c, !1, d, e);
  }

  function qb(a, b, c, d, e, f) {
    if (!b) throw Error("Invalid event type");
    var h = ea(e) ? !!e.capture : !!e,
        m = rb(a);
    m || (a[kb] = m = new hb(a));
    c = m.add(b, c, d, h, f);
    if (c.proxy) return c;
    d = sb();
    c.proxy = d;
    d.src = a;
    d.listener = c;
    if (a.addEventListener) ab || (e = h), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);else if (a.attachEvent) a.attachEvent(tb(b.toString()), d);else if (a.addListener && a.removeListener) a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");
    mb++;
    return c;
  }

  function sb() {
    var a = ub,
        b = Za ? function (c) {
      return a.call(b.src, b.listener, c);
    } : function (c) {
      c = a.call(b.src, b.listener, c);
      if (!c) return c;
    };
    return b;
  }

  function ob(a, b, c, d, e) {
    if (p(b)) {
      for (var f = 0; f < b.length; f++) {
        ob(a, b[f], c, d, e);
      }

      return null;
    }

    c = pb(c);
    return a && a[db] ? a.Ja(b, c, ea(d) ? !!d.capture : !!d, e) : qb(a, b, c, !0, d, e);
  }

  function vb(a, b, c, d, e) {
    if (p(b)) for (var f = 0; f < b.length; f++) {
      vb(a, b[f], c, d, e);
    } else (d = ea(d) ? !!d.capture : !!d, c = pb(c), a && a[db]) ? (a = a.f, b = String(b).toString(), b in a.a && (f = a.a[b], c = ib(f, c, d, e), -1 < c && (gb(f[c]), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.a[b], a.b--)))) : a && (a = rb(a)) && (b = a.a[b.toString()], a = -1, b && (a = ib(b, c, d, e)), (c = -1 < a ? b[a] : null) && wb(c));
  }

  function wb(a) {
    if ("number" != typeof a && a && !a.Z) {
      var b = a.src;
      if (b && b[db]) jb(b.f, a);else {
        var c = a.type,
            d = a.proxy;
        b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(tb(c), d) : b.addListener && b.removeListener && b.removeListener(d);
        mb--;
        (c = rb(b)) ? (jb(c, a), 0 == c.b && (c.src = null, b[kb] = null)) : gb(a);
      }
    }
  }

  function tb(a) {
    return a in lb ? lb[a] : lb[a] = "on" + a;
  }

  function xb(a, b, c, d) {
    var e = !0;
    if (a = rb(a)) if (b = a.a[b.toString()]) for (b = b.concat(), a = 0; a < b.length; a++) {
      var f = b[a];
      f && f.capture == c && !f.Z && (f = yb(f, d), e = e && !1 !== f);
    }
    return e;
  }

  function yb(a, b) {
    var c = a.listener,
        d = a.ga || a.src;
    a.ba && wb(a);
    return c.call(d, b);
  }

  function ub(a, b) {
    if (a.Z) return !0;

    if (!Za) {
      var c = b || n("window.event");
      b = new bb(c, this);
      var d = !0;

      if (!(0 > c.keyCode || void 0 != c.returnValue)) {
        a: {
          var e = !1;
          if (0 == c.keyCode) try {
            c.keyCode = -1;
            break a;
          } catch (h) {
            e = !0;
          }
          if (e || void 0 == c.returnValue) c.returnValue = !0;
        }

        c = [];

        for (e = b.a; e; e = e.parentNode) {
          c.push(e);
        }

        a = a.type;

        for (e = c.length - 1; 0 <= e; e--) {
          b.a = c[e];
          var f = xb(c[e], a, !0, b);
          d = d && f;
        }

        for (e = 0; e < c.length; e++) {
          b.a = c[e], f = xb(c[e], a, !1, b), d = d && f;
        }
      }

      return d;
    }

    return yb(a, new bb(b, this));
  }

  function rb(a) {
    a = a[kb];
    return a instanceof hb ? a : null;
  }

  var zb = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);

  function pb(a) {
    if (da(a)) return a;
    a[zb] || (a[zb] = function (b) {
      return a.handleEvent(b);
    });
    return a[zb];
  }

  ;

  function B() {
    w.call(this);
    this.f = new hb(this);
    this.N = this;
    this.J = null;
  }

  u(B, w);
  B.prototype[db] = !0;
  g = B.prototype;

  g.addEventListener = function (a, b, c, d) {
    nb(this, a, b, c, d);
  };

  g.removeEventListener = function (a, b, c, d) {
    vb(this, a, b, c, d);
  };

  g.dispatchEvent = function (a) {
    var b,
        c = this.J;
    if (c) for (b = []; c; c = c.J) {
      b.push(c);
    }
    c = this.N;
    var d = a.type || a;
    if (l(a)) a = new A(a, c);else if (a instanceof A) a.target = a.target || c;else {
      var e = a;
      a = new A(d, c);
      Ha(a, e);
    }
    e = !0;
    if (b) for (var f = b.length - 1; 0 <= f; f--) {
      var h = a.a = b[f];
      e = Ab(h, d, !0, a) && e;
    }
    h = a.a = c;
    e = Ab(h, d, !0, a) && e;
    e = Ab(h, d, !1, a) && e;
    if (b) for (f = 0; f < b.length; f++) {
      h = a.a = b[f], e = Ab(h, d, !1, a) && e;
    }
    return e;
  };

  g.w = function () {
    B.H.w.call(this);

    if (this.f) {
      var a = this.f,
          b = 0,
          c;

      for (c in a.a) {
        for (var d = a.a[c], e = 0; e < d.length; e++) {
          ++b, gb(d[e]);
        }

        delete a.a[c];
        a.b--;
      }
    }

    this.J = null;
  };

  g.Ia = function (a, b, c, d) {
    return this.f.add(String(a), b, !1, c, d);
  };

  g.Ja = function (a, b, c, d) {
    return this.f.add(String(a), b, !0, c, d);
  };

  function Ab(a, b, c, d) {
    b = a.f.a[String(b)];
    if (!b) return !0;
    b = b.concat();

    for (var e = !0, f = 0; f < b.length; ++f) {
      var h = b[f];

      if (h && !h.Z && h.capture == c) {
        var m = h.listener,
            v = h.ga || h.src;
        h.ba && jb(a.f, h);
        e = !1 !== m.call(v, d) && e;
      }
    }

    return e && 0 != d.Ra;
  }

  ;

  function Bb(a) {
    return /^\s*$/.test(a) ? !1 : /^[\],:{}\s\u2028\u2029]*$/.test(a.replace(/\\["\\\/bfnrtu]/g, "@").replace(/(?:"[^"\\\n\r\u2028\u2029\x00-\x08\x0a-\x1f]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)[\s\u2028\u2029]*(?=:|,|]|}|$)/g, "]").replace(/(?:^|:|,)(?:[\s\u2028\u2029]*\[)+/g, ""));
  }

  function Cb(a) {
    a = String(a);
    if (Bb(a)) try {
      return eval("(" + a + ")");
    } catch (b) {}
    throw Error("Invalid JSON string: " + a);
  }

  function Db(a) {
    var b = [];
    Eb(new Fb(), a, b);
    return b.join("");
  }

  function Fb() {}

  function Eb(a, b, c) {
    if (null == b) c.push("null");else {
      if ("object" == _typeof(b)) {
        if (p(b)) {
          var d = b;
          b = d.length;
          c.push("[");

          for (var e = "", f = 0; f < b; f++) {
            c.push(e), Eb(a, d[f], c), e = ",";
          }

          c.push("]");
          return;
        }

        if (b instanceof String || b instanceof Number || b instanceof Boolean) b = b.valueOf();else {
          c.push("{");
          e = "";

          for (d in b) {
            Object.prototype.hasOwnProperty.call(b, d) && (f = b[d], "function" != typeof f && (c.push(e), Gb(d, c), c.push(":"), Eb(a, f, c), e = ","));
          }

          c.push("}");
          return;
        }
      }

      switch (_typeof(b)) {
        case "string":
          Gb(b, c);
          break;

        case "number":
          c.push(isFinite(b) && !isNaN(b) ? String(b) : "null");
          break;

        case "boolean":
          c.push(String(b));
          break;

        case "function":
          c.push("null");
          break;

        default:
          throw Error("Unknown type: " + _typeof(b));
      }
    }
  }

  var Hb = {
    '"': '\\"',
    "\\": "\\\\",
    "/": "\\/",
    "\b": "\\b",
    "\f": "\\f",
    "\n": "\\n",
    "\r": "\\r",
    "\t": "\\t",
    "\x0B": "\\u000b"
  },
      Ib = /\uffff/.test("\uFFFF") ? /[\\"\x00-\x1f\x7f-\uffff]/g : /[\\"\x00-\x1f\x7f-\xff]/g;

  function Gb(a, b) {
    b.push('"', a.replace(Ib, function (a) {
      var b = Hb[a];
      b || (b = "\\u" + (a.charCodeAt(0) | 65536).toString(16).substr(1), Hb[a] = b);
      return b;
    }), '"');
  }

  ;

  function Jb(a, b) {
    this.c = a;
    this.f = b;
    this.b = 0;
    this.a = null;
  }

  Jb.prototype.get = function () {
    if (0 < this.b) {
      this.b--;
      var a = this.a;
      this.a = a.next;
      a.next = null;
    } else a = this.c();

    return a;
  };

  function Kb() {
    this.b = this.a = null;
  }

  var Nb = new Jb(function () {
    return new Lb();
  }, function (a) {
    a.reset();
  });

  Kb.prototype.add = function (a, b) {
    var c = Nb.get();
    c.set(a, b);
    this.b ? this.b.next = c : this.a = c;
    this.b = c;
  };

  function Ob() {
    var a = Pb,
        b = null;
    a.a && (b = a.a, a.a = a.a.next, a.a || (a.b = null), b.next = null);
    return b;
  }

  function Lb() {
    this.next = this.b = this.a = null;
  }

  Lb.prototype.set = function (a, b) {
    this.a = a;
    this.b = b;
    this.next = null;
  };

  Lb.prototype.reset = function () {
    this.next = this.b = this.a = null;
  };

  function Qb(a) {
    k.setTimeout(function () {
      throw a;
    }, 0);
  }

  var Rb;

  function Sb() {
    var a = k.MessageChannel;
    "undefined" === typeof a && "undefined" !== typeof window && window.postMessage && window.addEventListener && !y("Presto") && (a = function a() {
      var a = document.createElement("IFRAME");
      a.style.display = "none";
      a.src = "";
      document.documentElement.appendChild(a);
      var b = a.contentWindow;
      a = b.document;
      a.open();
      a.write("");
      a.close();
      var c = "callImmediate" + Math.random(),
          d = "file:" == b.location.protocol ? "*" : b.location.protocol + "//" + b.location.host;
      a = r(function (a) {
        if (("*" == d || a.origin == d) && a.data == c) this.port1.onmessage();
      }, this);
      b.addEventListener("message", a, !1);
      this.port1 = {};
      this.port2 = {
        postMessage: function postMessage() {
          b.postMessage(c, d);
        }
      };
    });

    if ("undefined" !== typeof a && !y("Trident") && !y("MSIE")) {
      var b = new a(),
          c = {},
          d = c;

      b.port1.onmessage = function () {
        if (void 0 !== c.next) {
          c = c.next;
          var a = c.za;
          c.za = null;
          a();
        }
      };

      return function (a) {
        d.next = {
          za: a
        };
        d = d.next;
        b.port2.postMessage(0);
      };
    }

    return "undefined" !== typeof document && "onreadystatechange" in document.createElement("SCRIPT") ? function (a) {
      var b = document.createElement("SCRIPT");

      b.onreadystatechange = function () {
        b.onreadystatechange = null;
        b.parentNode.removeChild(b);
        b = null;
        a();
        a = null;
      };

      document.documentElement.appendChild(b);
    } : function (a) {
      k.setTimeout(a, 0);
    };
  }

  ;
  var Tb;

  function Ub() {
    if (-1 != String(k.Promise).indexOf("[native code]")) {
      var a = k.Promise.resolve(void 0);

      Tb = function Tb() {
        a.then(Vb);
      };
    } else Tb = function Tb() {
      var a = Vb;
      !da(k.setImmediate) || k.Window && k.Window.prototype && !y("Edge") && k.Window.prototype.setImmediate == k.setImmediate ? (Rb || (Rb = Sb()), Rb(a)) : k.setImmediate(a);
    };
  }

  var Wb = !1,
      Pb = new Kb();

  function Vb() {
    for (var a; a = Ob();) {
      try {
        a.a.call(a.b);
      } catch (c) {
        Qb(c);
      }

      var b = Nb;
      b.f(a);
      100 > b.b && (b.b++, a.next = b.a, b.a = a);
    }

    Wb = !1;
  }

  ;

  function Xb(a, b) {
    B.call(this);
    this.b = a || 1;
    this.a = b || k;
    this.c = r(this.qb, this);
    this.g = t();
  }

  u(Xb, B);
  g = Xb.prototype;
  g.ea = !1;
  g.O = null;

  g.qb = function () {
    if (this.ea) {
      var a = t() - this.g;
      0 < a && a < .8 * this.b ? this.O = this.a.setTimeout(this.c, this.b - a) : (this.O && (this.a.clearTimeout(this.O), this.O = null), this.dispatchEvent("tick"), this.ea && (this.O = this.a.setTimeout(this.c, this.b), this.g = t()));
    }
  };

  g.start = function () {
    this.ea = !0;
    this.O || (this.O = this.a.setTimeout(this.c, this.b), this.g = t());
  };

  function Yb(a) {
    a.ea = !1;
    a.O && (a.a.clearTimeout(a.O), a.O = null);
  }

  g.w = function () {
    Xb.H.w.call(this);
    Yb(this);
    delete this.a;
  };

  function Zb(a, b, c) {
    if (da(a)) c && (a = r(a, c));else if (a && "function" == typeof a.handleEvent) a = r(a.handleEvent, a);else throw Error("Invalid listener argument");
    return 2147483647 < Number(b) ? -1 : k.setTimeout(a, b || 0);
  }

  ;

  function $b(a, b, c) {
    w.call(this);
    this.f = null != c ? r(a, c) : a;
    this.c = b;
    this.b = r(this.kb, this);
    this.a = [];
  }

  u($b, w);
  g = $b.prototype;
  g.ha = !1;
  g.Y = null;

  g.cb = function (a) {
    this.a = arguments;
    this.Y ? this.ha = !0 : ac(this);
  };

  g.w = function () {
    $b.H.w.call(this);
    this.Y && (k.clearTimeout(this.Y), this.Y = null, this.ha = !1, this.a = []);
  };

  g.kb = function () {
    this.Y = null;
    this.ha && (this.ha = !1, ac(this));
  };

  function ac(a) {
    a.Y = Zb(a.b, a.c);
    a.f.apply(null, a.a);
  }

  ;

  function bc(a) {
    w.call(this);
    this.b = a;
    this.a = {};
  }

  u(bc, w);
  var cc = [];

  function dc(a, b, c, d) {
    p(c) || (c && (cc[0] = c.toString()), c = cc);

    for (var e = 0; e < c.length; e++) {
      var f = nb(b, c[e], d || a.handleEvent, !1, a.b || a);
      if (!f) break;
      a.a[f.key] = f;
    }
  }

  function ec(a) {
    Ca(a.a, function (a, c) {
      this.a.hasOwnProperty(c) && wb(a);
    }, a);
    a.a = {};
  }

  bc.prototype.w = function () {
    bc.H.w.call(this);
    ec(this);
  };

  bc.prototype.handleEvent = function () {
    throw Error("EventHandler.handleEvent not implemented");
  };

  function fc(a, b, c) {
    this.reset(a, b, c, void 0, void 0);
  }

  fc.prototype.a = null;
  var gc = 0;

  fc.prototype.reset = function (a, b, c, d, e) {
    "number" == typeof e || gc++;
    d || t();
    delete this.a;
  };

  function hc(a) {
    this.f = a;
    this.b = this.c = this.a = null;
  }

  function C(a, b) {
    this.name = a;
    this.value = b;
  }

  C.prototype.toString = function () {
    return this.name;
  };

  var ic = new C("SEVERE", 1E3),
      jc = new C("WARNING", 900),
      kc = new C("INFO", 800),
      lc = new C("CONFIG", 700),
      mc = new C("FINE", 500);

  function nc(a) {
    if (a.c) return a.c;
    if (a.a) return nc(a.a);
    ma("Root logger has no level set.");
    return null;
  }

  hc.prototype.log = function (a, b, c) {
    if (a.value >= nc(this).value) for (da(b) && (b = b()), a = new fc(a, String(b), this.f), c && (a.a = c), c = this; c;) {
      c = c.a;
    }
  };

  var oc = {},
      pc = null;

  function qc(a) {
    pc || (pc = new hc(""), oc[""] = pc, pc.c = lc);
    var b;

    if (!(b = oc[a])) {
      b = new hc(a);
      var c = a.lastIndexOf("."),
          d = a.substr(c + 1);
      c = qc(a.substr(0, c));
      c.b || (c.b = {});
      c.b[d] = b;
      b.a = c;
      oc[a] = b;
    }

    return b;
  }

  ;

  function D(a, b) {
    a && a.log(jc, b, void 0);
  }

  function rc(a, b) {
    a && a.log(kc, b, void 0);
  }

  function E(a, b) {
    a && a.log(mc, b, void 0);
  }

  ;

  function sc() {
    this.a = qc("goog.labs.net.webChannel.WebChannelDebug");
    this.b = !0;
  }

  sc.prototype.Fa = function () {
    this.b = !1;
  };

  function tc(a, b, c, d, e, f) {
    F(a, function () {
      if (a.b) {
        if (f) {
          var h = "";

          for (var m = f.split("&"), v = 0; v < m.length; v++) {
            var I = m[v].split("=");

            if (1 < I.length) {
              var X = I[0];
              I = I[1];
              var Mb = X.split("_");
              h = 2 <= Mb.length && "type" == Mb[1] ? h + (X + "=" + I + "&") : h + (X + "=redacted&");
            }
          }
        } else h = null;
      } else h = f;
      return "XMLHTTP REQ (" + d + ") [attempt " + e + "]: " + b + "\n" + c + "\n" + h;
    });
  }

  function uc(a, b, c, d, e, f, h) {
    F(a, function () {
      return "XMLHTTP RESP (" + d + ") [ attempt " + e + "]: " + b + "\n" + c + "\n" + f + " " + h;
    });
  }

  function G(a, b, c, d) {
    F(a, function () {
      return "XMLHTTP TEXT (" + b + "): " + vc(a, c) + (d ? " " + d : "");
    });
  }

  function wc(a, b) {
    F(a, function () {
      return "TIMEOUT: " + b;
    });
  }

  function H(a, b) {
    E(a.a, b);
  }

  function xc(a, b, c) {
    (a = a.a) && a.log(ic, c || "Exception", b);
  }

  function F(a, b) {
    rc(a.a, b);
  }

  function J(a, b) {
    (a = a.a) && a.log(ic, b, void 0);
  }

  function vc(a, b) {
    if (!a.b) return b;
    if (!b) return null;

    try {
      var c = JSON.parse(b);
      if (c) for (var d = 0; d < c.length; d++) {
        if (p(c[d])) {
          var e = c[d];

          if (!(2 > e.length)) {
            var f = e[1];

            if (p(f) && !(1 > f.length)) {
              var h = f[0];
              if ("noop" != h && "stop" != h && "close" != h) for (var m = 1; m < f.length; m++) {
                f[m] = "";
              }
            }
          }
        }
      }
      return Db(c);
    } catch (v) {
      return H(a, "Exception parsing expected JS array - probably was not JS"), b;
    }
  }

  ;
  var yc = new B();

  function zc(a) {
    A.call(this, "serverreachability", a);
  }

  u(zc, A);

  function Ac(a) {
    yc.dispatchEvent(new zc(yc, a));
  }

  function Bc(a) {
    A.call(this, "statevent", a);
  }

  u(Bc, A);

  function K(a) {
    yc.dispatchEvent(new Bc(yc, a));
  }

  function Cc(a) {
    A.call(this, "timingevent", a);
  }

  u(Cc, A);

  function Dc(a, b, c) {
    yc.dispatchEvent(new Cc(yc, a, b, c));
  }

  function Ec(a, b) {
    if (!da(a)) throw Error("Fn must not be null and must be a function");
    return k.setTimeout(function () {
      a();
    }, b);
  }

  ;
  var Fc = {
    NO_ERROR: 0,
    rb: 1,
    yb: 2,
    xb: 3,
    ub: 4,
    wb: 5,
    zb: 6,
    Ua: 7,
    TIMEOUT: 8,
    Cb: 9
  };
  var Gc = {
    tb: "complete",
    Gb: "success",
    Va: "error",
    Ua: "abort",
    Eb: "ready",
    Fb: "readystatechange",
    TIMEOUT: "timeout",
    Ab: "incrementaldata",
    Db: "progress",
    vb: "downloadprogress",
    Hb: "uploadprogress"
  };

  function Hc() {}

  Hc.prototype.a = null;

  function Ic(a) {
    var b;
    (b = a.a) || (b = {}, Jc(a) && (b[0] = !0, b[1] = !0), b = a.a = b);
    return b;
  }

  ;

  function Kc() {}

  var Lc = {
    OPEN: "a",
    sb: "b",
    Va: "c",
    Bb: "d"
  };

  function Mc() {
    A.call(this, "d");
  }

  u(Mc, A);

  function Nc() {
    A.call(this, "c");
  }

  u(Nc, A);
  var Oc;

  function Pc() {}

  u(Pc, Hc);

  function Qc(a) {
    return (a = Jc(a)) ? new ActiveXObject(a) : new XMLHttpRequest();
  }

  function Jc(a) {
    if (!a.b && "undefined" == typeof XMLHttpRequest && "undefined" != typeof ActiveXObject) {
      for (var b = ["MSXML2.XMLHTTP.6.0", "MSXML2.XMLHTTP.3.0", "MSXML2.XMLHTTP", "Microsoft.XMLHTTP"], c = 0; c < b.length; c++) {
        var d = b[c];

        try {
          return new ActiveXObject(d), a.b = d;
        } catch (e) {}
      }

      throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");
    }

    return a.b;
  }

  Oc = new Pc();

  function L(a, b, c, d) {
    this.i = a;
    this.b = b;
    this.c = c;
    this.T = d || 1;
    this.L = new bc(this);
    this.R = Rc;
    a = Na ? 125 : void 0;
    this.S = new Xb(a);
    this.j = null;
    this.f = !1;
    this.l = this.g = this.h = this.J = this.D = this.U = this.s = null;
    this.u = [];
    this.a = null;
    this.G = 0;
    this.m = this.o = null;
    this.C = -1;
    this.B = !1;
    this.N = 0;
    this.I = null;
    this.v = this.X = this.K = !1;
  }

  var Rc = 45E3;

  function Sc(a, b) {
    switch (a) {
      case 0:
        return "Non-200 return code (" + b + ")";

      case 1:
        return "XMLHTTP failure (no data)";

      case 2:
        return "HttpConnection timeout";

      default:
        return "Unknown error";
    }
  }

  var Tc = {},
      Uc = {};
  g = L.prototype;

  g.setTimeout = function (a) {
    this.R = a;
  };

  function Vc(a, b, c) {
    a.J = 1;
    a.h = Wc(M(b));
    a.l = c;
    a.K = !0;
    Xc(a, null);
  }

  function Yc(a, b, c, d) {
    a.J = 1;
    a.h = Wc(M(b));
    a.l = null;
    a.K = c;
    Xc(a, d);
  }

  function Xc(a, b) {
    a.D = t();
    Zc(a);
    a.g = M(a.h);
    $c(a.g, "t", a.T);
    a.G = 0;
    a.a = a.i.ca(a.i.ia() ? b : null);
    0 < a.N && (a.I = new $b(r(a.Sa, a, a.a), a.N));
    dc(a.L, a.a, "readystatechange", a.nb);
    b = a.j ? Fa(a.j) : {};
    a.l ? (a.o || (a.o = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.a.fa(a.g, a.o, a.l, b)) : (a.o = "GET", a.a.fa(a.g, a.o, null, b));
    Ac(1);
    tc(a.b, a.o, a.g, a.c, a.T, a.l);
  }

  g.nb = function (a) {
    a = a.target;
    var b = this.I;
    b && 3 == N(a) ? (H(this.b, "Throttling readystatechange."), b.cb()) : this.Sa(a);
  };

  g.Sa = function (a) {
    try {
      a == this.a ? ad(this) : D(this.b.a, "Called back with an unexpected xmlhttp");
    } catch (c) {
      if (H(this.b, "Failed call to OnXmlHttpReadyStateChanged_"), this.a && this.a.V()) {
        var b = this;
        xc(this.b, c, function () {
          return "ResponseText: " + b.a.V();
        });
      } else xc(this.b, c, "No response text");
    } finally {}
  };

  function ad(a) {
    var b = N(a.a),
        c = a.a.Ga(),
        d = a.a.W();

    if (!(3 > b || 3 == b && !Na && !a.a.V())) {
      a.B || 4 != b || 7 == c || (8 == c || 0 >= d ? Ac(3) : Ac(2));
      bd(a);
      var e = a.a.W();
      a.C = e;
      (c = a.a.V()) || H(a.b, function () {
        return "No response text for uri " + a.g + " status " + e;
      });
      a.f = 200 == e;
      uc(a.b, a.o, a.g, a.c, a.T, b, e);

      if (a.f) {
        if (d = cd(a)) G(a.b, a.c, d, "Initial handshake response via X-HTTP-Initial-Response"), a.v = !0, dd(a, d);
        a.K ? (ed(a, b, c), Na && a.f && 3 == b && fd(a)) : (G(a.b, a.c, c, null), dd(a, c));
        4 == b && gd(a);
        a.f && !a.B && (4 == b ? a.i.ta(a) : (a.f = !1, Zc(a)));
      } else 400 == e && 0 < c.indexOf("Unknown SID") ? (a.m = 3, K(12), D(a.b.a, "XMLHTTP Unknown SID (" + a.c + ")")) : (a.m = 0, K(13), D(a.b.a, "XMLHTTP Bad status " + e + " (" + a.c + ")")), gd(a), hd(a);
    }
  }

  function cd(a) {
    return !a.X || a.v ? null : a.a && (a = id(a.a, "X-HTTP-Initial-Response")) && !xa(a) ? a : null;
  }

  function ed(a, b, c) {
    for (var d = !0; !a.B && a.G < c.length;) {
      var e = jd(a, c);

      if (e == Uc) {
        4 == b && (a.m = 4, K(14), d = !1);
        G(a.b, a.c, null, "[Incomplete Response]");
        break;
      } else if (e == Tc) {
        a.m = 4;
        K(15);
        G(a.b, a.c, c, "[Invalid Chunk]");
        d = !1;
        break;
      } else G(a.b, a.c, e, null), dd(a, e);
    }

    4 == b && 0 == c.length && (a.m = 1, K(16), d = !1);
    a.f = a.f && d;
    d || (G(a.b, a.c, c, "[Invalid Chunked Response]"), gd(a), hd(a));
  }

  g.mb = function () {
    if (this.a) {
      var a = N(this.a),
          b = this.a.V();
      this.G < b.length && (bd(this), ed(this, a, b), this.f && 4 != a && Zc(this));
    }
  };

  function fd(a) {
    dc(a.L, a.S, "tick", a.mb);
    a.S.start();
  }

  function jd(a, b) {
    var c = a.G,
        d = b.indexOf("\n", c);
    if (-1 == d) return Uc;
    c = Number(b.substring(c, d));
    if (isNaN(c)) return Tc;
    d += 1;
    if (d + c > b.length) return Uc;
    b = b.substr(d, c);
    a.G = d + c;
    return b;
  }

  g.cancel = function () {
    this.B = !0;
    gd(this);
  };

  function Zc(a) {
    a.U = t() + a.R;
    kd(a, a.R);
  }

  function kd(a, b) {
    if (null != a.s) throw Error("WatchDog timer not null");
    a.s = Ec(r(a.lb, a), b);
  }

  function bd(a) {
    a.s && (k.clearTimeout(a.s), a.s = null);
  }

  g.lb = function () {
    this.s = null;
    var a = t();
    0 <= a - this.U ? (this.f && J(this.b, "Received watchdog timeout even though request loaded successfully"), wc(this.b, this.g), 2 != this.J && (Ac(3), K(17)), gd(this), this.m = 2, hd(this)) : (D(this.b.a, "WatchDog timer called too early"), kd(this, this.U - a));
  };

  function hd(a) {
    a.i.La() || a.B || a.i.ta(a);
  }

  function gd(a) {
    bd(a);
    var b = a.I;
    b && "function" == typeof b.$ && b.$();
    a.I = null;
    Yb(a.S);
    ec(a.L);
    a.a && (b = a.a, a.a = null, b.abort(), b.$());
  }

  function dd(a, b) {
    try {
      a.i.Oa(a, b), Ac(4);
    } catch (c) {
      xc(a.b, c, "Error in httprequest callback");
    }
  }

  ;

  function ld(a) {
    if (a.A && "function" == typeof a.A) return a.A();
    if (l(a)) return a.split("");

    if (ca(a)) {
      for (var b = [], c = a.length, d = 0; d < c; d++) {
        b.push(a[d]);
      }

      return b;
    }

    return Da(a);
  }

  function md(a, b) {
    if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);else if (ca(a) || l(a)) ra(a, b, void 0);else {
      if (a.M && "function" == typeof a.M) var c = a.M();else if (a.A && "function" == typeof a.A) c = void 0;else if (ca(a) || l(a)) {
        c = [];

        for (var d = a.length, e = 0; e < d; e++) {
          c.push(e);
        }
      } else c = Ea(a);
      d = ld(a);
      e = d.length;

      for (var f = 0; f < e; f++) {
        b.call(void 0, d[f], c && c[f], a);
      }
    }
  }

  ;

  function O(a, b) {
    this.b = {};
    this.a = [];
    this.c = 0;
    var c = arguments.length;

    if (1 < c) {
      if (c % 2) throw Error("Uneven number of arguments");

      for (var d = 0; d < c; d += 2) {
        this.set(arguments[d], arguments[d + 1]);
      }
    } else if (a) if (a instanceof O) for (c = a.M(), d = 0; d < c.length; d++) {
      this.set(c[d], a.get(c[d]));
    } else for (d in a) {
      this.set(d, a[d]);
    }
  }

  g = O.prototype;

  g.A = function () {
    nd(this);

    for (var a = [], b = 0; b < this.a.length; b++) {
      a.push(this.b[this.a[b]]);
    }

    return a;
  };

  g.M = function () {
    nd(this);
    return this.a.concat();
  };

  function od(a) {
    a.b = {};
    a.a.length = 0;
    a.c = 0;
  }

  function pd(a, b) {
    return P(a.b, b) ? (delete a.b[b], a.c--, a.a.length > 2 * a.c && nd(a), !0) : !1;
  }

  function nd(a) {
    if (a.c != a.a.length) {
      for (var b = 0, c = 0; b < a.a.length;) {
        var d = a.a[b];
        P(a.b, d) && (a.a[c++] = d);
        b++;
      }

      a.a.length = c;
    }

    if (a.c != a.a.length) {
      var e = {};

      for (c = b = 0; b < a.a.length;) {
        d = a.a[b], P(e, d) || (a.a[c++] = d, e[d] = 1), b++;
      }

      a.a.length = c;
    }
  }

  g.get = function (a, b) {
    return P(this.b, a) ? this.b[a] : b;
  };

  g.set = function (a, b) {
    P(this.b, a) || (this.c++, this.a.push(a));
    this.b[a] = b;
  };

  g.forEach = function (a, b) {
    for (var c = this.M(), d = 0; d < c.length; d++) {
      var e = c[d],
          f = this.get(e);
      a.call(b, f, e, this);
    }
  };

  function P(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
  }

  ;
  var qd = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;

  function rd(a, b) {
    if (a) {
      a = a.split("&");

      for (var c = 0; c < a.length; c++) {
        var d = a[c].indexOf("="),
            e = null;

        if (0 <= d) {
          var f = a[c].substring(0, d);
          e = a[c].substring(d + 1);
        } else f = a[c];

        b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
      }
    }
  }

  ;

  function Q(a, b) {
    this.b = this.j = this.f = "";
    this.i = null;
    this.g = this.a = "";
    this.h = !1;
    var c;
    a instanceof Q ? (this.h = void 0 !== b ? b : a.h, sd(this, a.f), this.j = a.j, td(this, a.b), ud(this, a.i), this.a = a.a, vd(this, wd(a.c)), this.g = a.g) : a && (c = String(a).match(qd)) ? (this.h = !!b, sd(this, c[1] || "", !0), this.j = xd(c[2] || ""), td(this, c[3] || "", !0), ud(this, c[4]), this.a = xd(c[5] || "", !0), vd(this, c[6] || "", !0), this.g = xd(c[7] || "")) : (this.h = !!b, this.c = new yd(null, this.h));
  }

  Q.prototype.toString = function () {
    var a = [],
        b = this.f;
    b && a.push(zd(b, Ad, !0), ":");
    var c = this.b;
    if (c || "file" == b) a.push("//"), (b = this.j) && a.push(zd(b, Ad, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.i, null != c && a.push(":", String(c));
    if (c = this.a) this.b && "/" != c.charAt(0) && a.push("/"), a.push(zd(c, "/" == c.charAt(0) ? Bd : Cd, !0));
    (c = this.c.toString()) && a.push("?", c);
    (c = this.g) && a.push("#", zd(c, Dd));
    return a.join("");
  };

  Q.prototype.resolve = function (a) {
    var b = M(this),
        c = !!a.f;
    c ? sd(b, a.f) : c = !!a.j;
    c ? b.j = a.j : c = !!a.b;
    c ? td(b, a.b) : c = null != a.i;
    var d = a.a;
    if (c) ud(b, a.i);else if (c = !!a.a) {
      if ("/" != d.charAt(0)) if (this.b && !this.a) d = "/" + d;else {
        var e = b.a.lastIndexOf("/");
        -1 != e && (d = b.a.substr(0, e + 1) + d);
      }
      e = d;
      if (".." == e || "." == e) d = "";else if (-1 != e.indexOf("./") || -1 != e.indexOf("/.")) {
        d = 0 == e.lastIndexOf("/", 0);
        e = e.split("/");

        for (var f = [], h = 0; h < e.length;) {
          var m = e[h++];
          "." == m ? d && h == e.length && f.push("") : ".." == m ? ((1 < f.length || 1 == f.length && "" != f[0]) && f.pop(), d && h == e.length && f.push("")) : (f.push(m), d = !0);
        }

        d = f.join("/");
      } else d = e;
    }
    c ? b.a = d : c = "" !== a.c.toString();
    c ? vd(b, wd(a.c)) : c = !!a.g;
    c && (b.g = a.g);
    return b;
  };

  function M(a) {
    return new Q(a);
  }

  function sd(a, b, c) {
    a.f = c ? xd(b, !0) : b;
    a.f && (a.f = a.f.replace(/:$/, ""));
  }

  function td(a, b, c) {
    a.b = c ? xd(b, !0) : b;
  }

  function ud(a, b) {
    if (b) {
      b = Number(b);
      if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
      a.i = b;
    } else a.i = null;
  }

  function vd(a, b, c) {
    b instanceof yd ? (a.c = b, Ed(a.c, a.h)) : (c || (b = zd(b, Fd)), a.c = new yd(b, a.h));
  }

  function R(a, b, c) {
    a.c.set(b, c);
  }

  function $c(a, b, c) {
    p(c) || (c = [String(c)]);
    Gd(a.c, b, c);
  }

  function Wc(a) {
    R(a, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ t()).toString(36));
    return a;
  }

  function Hd(a) {
    return a instanceof Q ? M(a) : new Q(a, void 0);
  }

  function Id(a, b, c, d) {
    var e = new Q(null, void 0);
    a && sd(e, a);
    b && td(e, b);
    c && ud(e, c);
    d && (e.a = d);
    return e;
  }

  function xd(a, b) {
    return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
  }

  function zd(a, b, c) {
    return l(a) ? (a = encodeURI(a).replace(b, Jd), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
  }

  function Jd(a) {
    a = a.charCodeAt(0);
    return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
  }

  var Ad = /[#\/\?@]/g,
      Cd = /[#\?:]/g,
      Bd = /[#\?]/g,
      Fd = /[#\?@]/g,
      Dd = /#/g;

  function yd(a, b) {
    this.b = this.a = null;
    this.c = a || null;
    this.f = !!b;
  }

  function S(a) {
    a.a || (a.a = new O(), a.b = 0, a.c && rd(a.c, function (b, c) {
      a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
    }));
  }

  g = yd.prototype;

  g.add = function (a, b) {
    S(this);
    this.c = null;
    a = Kd(this, a);
    var c = this.a.get(a);
    c || this.a.set(a, c = []);
    c.push(b);
    this.b += 1;
    return this;
  };

  function Ld(a, b) {
    S(a);
    b = Kd(a, b);
    P(a.a.b, b) && (a.c = null, a.b -= a.a.get(b).length, pd(a.a, b));
  }

  function Md(a, b) {
    S(a);
    b = Kd(a, b);
    return P(a.a.b, b);
  }

  g.forEach = function (a, b) {
    S(this);
    this.a.forEach(function (c, d) {
      ra(c, function (c) {
        a.call(b, c, d, this);
      }, this);
    }, this);
  };

  g.M = function () {
    S(this);

    for (var a = this.a.A(), b = this.a.M(), c = [], d = 0; d < b.length; d++) {
      for (var e = a[d], f = 0; f < e.length; f++) {
        c.push(b[d]);
      }
    }

    return c;
  };

  g.A = function (a) {
    S(this);
    var b = [];
    if (l(a)) Md(this, a) && (b = va(b, this.a.get(Kd(this, a))));else {
      a = this.a.A();

      for (var c = 0; c < a.length; c++) {
        b = va(b, a[c]);
      }
    }
    return b;
  };

  g.set = function (a, b) {
    S(this);
    this.c = null;
    a = Kd(this, a);
    Md(this, a) && (this.b -= this.a.get(a).length);
    this.a.set(a, [b]);
    this.b += 1;
    return this;
  };

  g.get = function (a, b) {
    a = a ? this.A(a) : [];
    return 0 < a.length ? String(a[0]) : b;
  };

  function Gd(a, b, c) {
    Ld(a, b);
    0 < c.length && (a.c = null, a.a.set(Kd(a, b), wa(c)), a.b += c.length);
  }

  g.toString = function () {
    if (this.c) return this.c;
    if (!this.a) return "";

    for (var a = [], b = this.a.M(), c = 0; c < b.length; c++) {
      var d = b[c],
          e = encodeURIComponent(String(d));
      d = this.A(d);

      for (var f = 0; f < d.length; f++) {
        var h = e;
        "" !== d[f] && (h += "=" + encodeURIComponent(String(d[f])));
        a.push(h);
      }
    }

    return this.c = a.join("&");
  };

  function wd(a) {
    var b = new yd();
    b.c = a.c;
    a.a && (b.a = new O(a.a), b.b = a.b);
    return b;
  }

  function Kd(a, b) {
    b = String(b);
    a.f && (b = b.toLowerCase());
    return b;
  }

  function Ed(a, b) {
    b && !a.f && (S(a), a.c = null, a.a.forEach(function (a, b) {
      var c = b.toLowerCase();
      b != c && (Ld(this, b), Gd(this, c, a));
    }, a));
    a.f = b;
  }

  ;

  function Nd() {
    this.a = t();
  }

  var Od = null;

  Nd.prototype.set = function (a) {
    this.a = a;
  };

  Nd.prototype.reset = function () {
    this.set(t());
  };

  Nd.prototype.get = function () {
    return this.a;
  };

  function Pd() {
    Od || (Od = new Nd());
  }

  function Qd() {
    Od || (Od = new Nd());
  }

  u(Qd, Pd);

  function Rd(a, b) {
    this.a = a;
    this.b = b;
    this.c = this.i = null;
    this.h = !1;
    this.m = null;
    this.f = -1;
    this.l = this.g = null;
  }

  g = Rd.prototype;
  g.P = null;

  function Sd(a) {
    H(a.b, "TestConnection: starting stage 2");
    var b = a.a.I.a;
    if (null != b) H(a.b, function () {
      return "TestConnection: skipping stage 2, precomputed result is " + b ? "Buffered" : "Unbuffered";
    }), K(4), b ? (K(10), Td(a.a, a, !1)) : (K(11), Td(a.a, a, !0));else {
      a.c = new L(a, a.b, void 0, void 0);
      a.c.j = a.i;
      var c = Ud(a.a, a.g, a.m);
      K(4);
      $c(c, "TYPE", "xmlhttp");
      var d = a.a.j,
          e = a.a.K;
      d && e && R(c, d, e);
      Yc(a.c, c, !1, a.g);
    }
  }

  g.ca = function (a) {
    return this.a.ca(a);
  };

  g.abort = function () {
    this.c && (this.c.cancel(), this.c = null);
    this.f = -1;
  };

  g.La = function () {
    return !1;
  };

  g.Oa = function (a, b) {
    this.f = a.C;

    if (0 == this.P) {
      H(this.b, "TestConnection: Got data for stage 1");

      if (!this.a.o && (a = a.a)) {
        var c = id(a, "X-Client-Wire-Protocol");
        this.l = c ? c : null;
        this.a.j && ((a = id(a, "X-HTTP-Session-Id")) ? this.a.K = a : D(this.b.a, "Missing X_HTTP_SESSION_ID in the handshake response"));
      }

      if (b) {
        try {
          var d = this.a.la.a.parse(b);
        } catch (e) {
          xc(this.b, e);
          Vd(this.a, this);
          return;
        }

        this.g = d[0];
      } else H(this.b, "TestConnection: Null responseText"), Vd(this.a, this);
    } else if (1 == this.P) if (this.h) K(6);else if ("11111" == b) {
      if (K(5), this.h = !0, !z || 10 <= Number(Wa)) this.f = 200, this.c.cancel(), H(this.b, "Test connection succeeded; using streaming connection"), K(11), Td(this.a, this, !0);
    } else K(7), this.h = !1;
  };

  g.ta = function () {
    this.f = this.c.C;
    this.c.f ? 0 == this.P ? (this.P = 1, H(this.b, "TestConnection: request complete for initial check"), Sd(this)) : 1 == this.P && (H(this.b, "TestConnection: request complete for stage 2"), this.h ? (H(this.b, "Test connection succeeded; using streaming connection"), K(11), Td(this.a, this, !0)) : (H(this.b, "Test connection failed; not using streaming"), K(10), Td(this.a, this, !1))) : (H(this.b, "TestConnection: request failed, in state " + this.P), 0 == this.P ? K(8) : 1 == this.P && K(9), Vd(this.a, this));
  };

  g.ia = function () {
    return this.a.ia();
  };

  g.qa = function () {
    return this.a.qa();
  };

  function Wd() {
    this.a = this.b = null;
  }

  ;

  function Xd() {
    this.a = new O();
  }

  function Yd(a) {
    var b = _typeof(a);

    return "object" == b && a || "function" == b ? "o" + (a[q] || (a[q] = ++fa)) : b.charAt(0) + a;
  }

  Xd.prototype.add = function (a) {
    this.a.set(Yd(a), a);
  };

  Xd.prototype.A = function () {
    return this.a.A();
  };

  function Zd(a, b) {
    this.a = a;
    this.b = b;
  }

  ;

  function $d(a) {
    this.g = a || ae;
    k.PerformanceNavigationTiming ? (a = k.performance.getEntriesByType("navigation"), a = 0 < a.length && ("hq" == a[0].nextHopProtocol || "h2" == a[0].nextHopProtocol)) : a = !!(k.oa && k.oa.Ma && k.oa.Ma() && k.oa.Ma().Jb);
    this.f = a ? this.g : 1;
    this.a = null;
    1 < this.f && (this.a = new Xd());
    this.b = null;
    this.c = [];
  }

  var ae = 10;

  function be(a, b) {
    a.a || -1 == b.indexOf("spdy") && -1 == b.indexOf("quic") && -1 == b.indexOf("h2") || (a.f = a.g, a.a = new Xd(), a.b && (ce(a, a.b), a.b = null));
  }

  function de(a) {
    return a.b ? !0 : a.a ? a.a.a.c >= a.f : !1;
  }

  function ee(a, b) {
    a.b ? a = a.b == b : a.a ? (b = Yd(b), a = P(a.a.a.b, b)) : a = !1;
    return a;
  }

  function ce(a, b) {
    a.a ? a.a.add(b) : a.b = b;
  }

  function fe(a, b) {
    if (a.b && a.b == b) a.b = null;else {
      var c;
      if (c = a.a) c = Yd(b), c = P(a.a.a.b, c);
      c && pd(a.a.a, Yd(b));
    }
  }

  $d.prototype.cancel = function () {
    this.c = ge(this);
    this.b ? (this.b.cancel(), this.b = null) : this.a && 0 != this.a.a.c && (ra(this.a.A(), function (a) {
      a.cancel();
    }), od(this.a.a));
  };

  function ge(a) {
    if (null != a.b) return a.c.concat(a.b.u);

    if (null != a.a && 0 != a.a.a.c) {
      var b = a.c;
      ra(a.a.A(), function (a) {
        b = b.concat(a.u);
      });
      return b;
    }

    return wa(a.c);
  }

  function he(a, b) {
    a.c = a.c.concat(b);
  }

  ;

  function ie() {}

  ie.prototype.stringify = function (a) {
    return k.JSON.stringify(a, void 0);
  };

  ie.prototype.parse = function (a) {
    return k.JSON.parse(a, void 0);
  };

  function je() {
    this.a = new ie();
  }

  function ke(a, b, c) {
    var d = c || "";

    try {
      md(a, function (a, c) {
        var e = a;
        ea(a) && (e = Db(a));
        b.push(d + c + "=" + encodeURIComponent(e));
      });
    } catch (e) {
      throw b.push(d + "type=" + encodeURIComponent("_badmap")), e;
    }
  }

  ;

  function le(a, b) {
    var c = new sc();
    H(c, "TestLoadImage: loading " + a);
    var d = new Image();
    d.onload = ja(me, c, d, "TestLoadImage: loaded", !0, b);
    d.onerror = ja(me, c, d, "TestLoadImage: error", !1, b);
    d.onabort = ja(me, c, d, "TestLoadImage: abort", !1, b);
    d.ontimeout = ja(me, c, d, "TestLoadImage: timeout", !1, b);
    k.setTimeout(function () {
      if (d.ontimeout) d.ontimeout();
    }, 1E4);
    d.src = a;
  }

  function me(a, b, c, d, e) {
    try {
      H(a, c), b.onload = null, b.onerror = null, b.onabort = null, b.ontimeout = null, e(d);
    } catch (f) {
      xc(a, f);
    }
  }

  ;

  function T(a) {
    B.call(this);
    this.headers = new O();
    this.s = a || null;
    this.c = !1;
    this.D = this.a = null;
    this.K = this.B = "";
    this.j = 0;
    this.g = "";
    this.h = this.I = this.u = this.G = !1;
    this.l = 0;
    this.C = null;
    this.L = ne;
    this.v = this.o = !1;
  }

  u(T, B);
  var ne = "";
  T.prototype.b = qc("goog.net.XhrIo");
  var oe = /^https?$/i,
      pe = ["POST", "PUT"];
  g = T.prototype;

  g.fa = function (a, b, c, d) {
    if (this.a) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.B + "; newUri=" + a);
    b = b ? b.toUpperCase() : "GET";
    this.B = a;
    this.g = "";
    this.j = 0;
    this.K = b;
    this.G = !1;
    this.c = !0;
    this.a = this.s ? Qc(this.s) : Qc(Oc);
    this.D = this.s ? Ic(this.s) : Ic(Oc);
    this.a.onreadystatechange = r(this.Na, this);

    try {
      E(this.b, U(this, "Opening Xhr")), this.I = !0, this.a.open(b, String(a), !0), this.I = !1;
    } catch (f) {
      E(this.b, U(this, "Error opening Xhr: " + f.message));
      qe(this, f);
      return;
    }

    a = c || "";
    var e = new O(this.headers);
    d && md(d, function (a, b) {
      e.set(b, a);
    });
    d = sa(e.M());
    c = k.FormData && a instanceof k.FormData;
    !(0 <= qa(pe, b)) || d || c || e.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
    e.forEach(function (a, b) {
      this.a.setRequestHeader(b, a);
    }, this);
    this.L && (this.a.responseType = this.L);
    "withCredentials" in this.a && this.a.withCredentials !== this.o && (this.a.withCredentials = this.o);

    try {
      re(this), 0 < this.l && (this.v = se(this.a), E(this.b, U(this, "Will abort after " + this.l + "ms if incomplete, xhr2 " + this.v)), this.v ? (this.a.timeout = this.l, this.a.ontimeout = r(this.Ka, this)) : this.C = Zb(this.Ka, this.l, this)), E(this.b, U(this, "Sending request")), this.u = !0, this.a.send(a), this.u = !1;
    } catch (f) {
      E(this.b, U(this, "Send error: " + f.message)), qe(this, f);
    }
  };

  function se(a) {
    return z && Va(9) && "number" == typeof a.timeout && void 0 !== a.ontimeout;
  }

  function ta(a) {
    return "content-type" == a.toLowerCase();
  }

  g.Ka = function () {
    "undefined" != typeof goog && this.a && (this.g = "Timed out after " + this.l + "ms, aborting", this.j = 8, E(this.b, U(this, this.g)), this.dispatchEvent("timeout"), this.abort(8));
  };

  function qe(a, b) {
    a.c = !1;
    a.a && (a.h = !0, a.a.abort(), a.h = !1);
    a.g = b;
    a.j = 5;
    te(a);
    ue(a);
  }

  function te(a) {
    a.G || (a.G = !0, a.dispatchEvent("complete"), a.dispatchEvent("error"));
  }

  g.abort = function (a) {
    this.a && this.c && (E(this.b, U(this, "Aborting")), this.c = !1, this.h = !0, this.a.abort(), this.h = !1, this.j = a || 7, this.dispatchEvent("complete"), this.dispatchEvent("abort"), ue(this));
  };

  g.w = function () {
    this.a && (this.c && (this.c = !1, this.h = !0, this.a.abort(), this.h = !1), ue(this, !0));
    T.H.w.call(this);
  };

  g.Na = function () {
    this.i || (this.I || this.u || this.h ? ve(this) : this.jb());
  };

  g.jb = function () {
    ve(this);
  };

  function ve(a) {
    if (a.c && "undefined" != typeof goog) if (a.D[1] && 4 == N(a) && 2 == a.W()) E(a.b, U(a, "Local request error detected and ignored"));else if (a.u && 4 == N(a)) Zb(a.Na, 0, a);else if (a.dispatchEvent("readystatechange"), 4 == N(a)) {
      E(a.b, U(a, "Request complete"));
      a.c = !1;

      try {
        var b = a.W();

        a: switch (b) {
          case 200:
          case 201:
          case 202:
          case 204:
          case 206:
          case 304:
          case 1223:
            var c = !0;
            break a;

          default:
            c = !1;
        }

        var d;

        if (!(d = c)) {
          var e;

          if (e = 0 === b) {
            var f = String(a.B).match(qd)[1] || null;

            if (!f && k.self && k.self.location) {
              var h = k.self.location.protocol;
              f = h.substr(0, h.length - 1);
            }

            e = !oe.test(f ? f.toLowerCase() : "");
          }

          d = e;
        }

        d ? (a.dispatchEvent("complete"), a.dispatchEvent("success")) : (a.j = 6, a.g = a.Ha() + " [" + a.W() + "]", te(a));
      } finally {
        ue(a);
      }
    }
  }

  function ue(a, b) {
    if (a.a) {
      re(a);
      var c = a.a,
          d = a.D[0] ? aa : null;
      a.a = null;
      a.D = null;
      b || a.dispatchEvent("ready");

      try {
        c.onreadystatechange = d;
      } catch (e) {
        (a = a.b) && a.log(ic, "Problem encountered resetting onreadystatechange: " + e.message, void 0);
      }
    }
  }

  function re(a) {
    a.a && a.v && (a.a.ontimeout = null);
    a.C && (k.clearTimeout(a.C), a.C = null);
  }

  function N(a) {
    return a.a ? a.a.readyState : 0;
  }

  g.W = function () {
    try {
      return 2 < N(this) ? this.a.status : -1;
    } catch (a) {
      return -1;
    }
  };

  g.Ha = function () {
    try {
      return 2 < N(this) ? this.a.statusText : "";
    } catch (a) {
      return E(this.b, "Can not get status: " + a.message), "";
    }
  };

  g.V = function () {
    try {
      return this.a ? this.a.responseText : "";
    } catch (a) {
      return E(this.b, "Can not get responseText: " + a.message), "";
    }
  };

  g.eb = function (a) {
    if (this.a) {
      var b = this.a.responseText;
      a && 0 == b.indexOf(a) && (b = b.substring(a.length));

      a: {
        a = b;
        if (k.JSON) try {
          var c = k.JSON.parse(a);
          break a;
        } catch (d) {}
        c = Cb(a);
      }

      return c;
    }
  };

  function id(a, b) {
    return a.a ? a.a.getResponseHeader(b) : null;
  }

  g.Ga = function () {
    return this.j;
  };

  g.hb = function () {
    return l(this.g) ? this.g : String(this.g);
  };

  function U(a, b) {
    return b + " [" + a.K + " " + a.B + " " + a.W() + "]";
  }

  ;

  function we(a) {
    var b = "";
    Ca(a, function (a, d) {
      b += d;
      b += ":";
      b += a;
      b += "\r\n";
    });
    return b;
  }

  function xe(a, b, c) {
    a: {
      for (d in c) {
        var d = !1;
        break a;
      }

      d = !0;
    }

    if (d) return a;
    c = we(c);

    if (l(a)) {
      b = encodeURIComponent(String(b));
      c = null != c ? "=" + encodeURIComponent(String(c)) : "";

      if (b += c) {
        c = a.indexOf("#");
        0 > c && (c = a.length);
        d = a.indexOf("?");

        if (0 > d || d > c) {
          d = c;
          var e = "";
        } else e = a.substring(d + 1, c);

        a = [a.substr(0, d), e, a.substr(c)];
        c = a[1];
        a[1] = b ? c ? c + "&" + b : b : c;
        a = a[0] + (a[1] ? "?" + a[1] : "") + a[2];
      }

      return a;
    }

    R(a, b, c);
    return a;
  }

  ;

  function ye(a) {
    this.ya = 0;
    this.g = [];
    this.a = new sc();
    this.I = new Wd();
    this.X = this.ua = this.D = this.ja = this.b = this.K = this.j = this.U = this.h = this.L = this.i = null;
    this.Za = this.R = 0;
    this.Xa = !!n("internalChannelParams.failFast", a);
    this.ka = this.C = this.s = this.l = this.m = this.f = null;
    this.u = this.xa = this.N = -1;
    this.T = this.B = this.v = 0;
    this.Wa = n("internalChannelParams.baseRetryDelayMs", a) || 5E3;
    this.$a = n("internalChannelParams.retryDelaySeedMs", a) || 1E4;
    this.Ya = n("internalChannelParams.forwardChannelMaxRetries", a) || 2;
    this.wa = n("internalChannelParams.forwardChannelRequestTimeoutMs", a) || 2E4;
    this.Ta = a && a.Kb || void 0;
    this.G = void 0;
    this.S = a && a.supportsCrossDomainXhr || !1;
    this.J = "";
    this.c = new $d(a && a.concurrentRequestLimit);
    this.la = new je();
    this.o = a && void 0 !== a.backgroundChannelTest ? a.backgroundChannelTest : !0;
    (this.va = a && a.fastHandshake || !1) && !this.o && (D(this.a.a, "Force backgroundChannelTest when fastHandshake is enabled."), this.o = !0);
    a && a.Fa && this.a.Fa();
  }

  g = ye.prototype;
  g.na = 8;
  g.F = 1;

  function ze(a) {
    H(a.a, "disconnect()");
    Ae(a);

    if (3 == a.F) {
      var b = a.R++,
          c = M(a.D);
      R(c, "SID", a.J);
      R(c, "RID", b);
      R(c, "TYPE", "terminate");
      Be(a, c);
      b = new L(a, a.a, b, void 0);
      b.J = 2;
      b.h = Wc(M(c));
      c = !1;
      k.navigator && k.navigator.sendBeacon && (c = k.navigator.sendBeacon(b.h.toString(), ""));
      !c && k.Image && (new Image().src = b.h, c = !0);
      c || (b.a = b.i.ca(null), b.a.fa(b.h));
      b.D = t();
      Zc(b);
    }

    Ce(a);
  }

  function Ae(a) {
    a.C && (a.C.abort(), a.C = null);
    a.b && (a.b.cancel(), a.b = null);
    a.l && (k.clearTimeout(a.l), a.l = null);
    De(a);
    a.c.cancel();
    a.m && (k.clearTimeout(a.m), a.m = null);
  }

  function Ee(a, b) {
    1E3 == a.g.length && J(a.a, function () {
      return "Already have 1000 queued maps upon queueing " + Db(b);
    });
    a.g.push(new Zd(a.Za++, b));
    3 == a.F && Fe(a);
  }

  g.La = function () {
    return 0 == this.F;
  };

  function Fe(a) {
    de(a.c) || a.m || (a.m = Ec(r(a.Qa, a), 0), a.v = 0);
  }

  function Ge(a, b) {
    var c = a.c;
    if ((c.b ? 1 : c.a ? c.a.a.c : 0) >= a.c.f - (a.m ? 1 : 0)) return J(a.a, "Unexpected retry request is scheduled."), !1;
    if (a.m) return H(a.a, "Use the retry request that is already scheduled."), a.g = b.u.concat(a.g), !0;
    if (1 == a.F || 2 == a.F || a.v >= (a.Xa ? 0 : a.Ya)) return !1;
    H(a.a, "Going to retry POST");
    a.m = Ec(r(a.Qa, a, b), He(a, a.v));
    a.v++;
    return !0;
  }

  g.Qa = function (a) {
    this.m = null;
    H(this.a, "startForwardChannel_");
    if (1 == this.F) {
      if (a) J(this.a, "Not supposed to retry the open");else {
        H(this.a, "open_()");
        this.R = Math.floor(1E5 * Math.random());
        a = this.R++;
        var b = new L(this, this.a, a, void 0),
            c = this.i;
        this.L && (c ? (c = Fa(c), Ha(c, this.L)) : c = this.L);
        null === this.h && (b.j = c);
        var d = Ie(this, b),
            e = M(this.D);
        R(e, "RID", a);
        R(e, "CVER", 22);
        this.o && this.j && R(e, "X-HTTP-Session-Id", this.j);
        Be(this, e);
        this.h && c && xe(e, this.h, c);
        ce(this.c, b);
        this.va ? (R(e, "$req", d), R(e, "SID", "null"), b.X = !0, Vc(b, e, null)) : Vc(b, e, d);
        this.F = 2;
      }
    } else 3 == this.F && (a ? Je(this, a) : 0 == this.g.length ? H(this.a, "startForwardChannel_ returned: nothing to send") : de(this.c) ? J(this.a, "startForwardChannel_ returned: connection already in progress") : (Je(this), H(this.a, "startForwardChannel_ finished, sent request")));
  };

  function Je(a, b) {
    var c;
    b ? c = b.c : c = a.R++;
    var d = M(a.D);
    R(d, "SID", a.J);
    R(d, "RID", c);
    R(d, "AID", a.N);
    Be(a, d);
    a.h && a.i && xe(d, a.h, a.i);
    c = new L(a, a.a, c, a.v + 1);
    null === a.h && (c.j = a.i);
    b && (a.g = b.u.concat(a.g));
    b = Ie(a, c);
    c.setTimeout(Math.round(.5 * a.wa) + Math.round(.5 * a.wa * Math.random()));
    ce(a.c, c);
    Vc(c, d, b);
  }

  function Be(a, b) {
    a.f && md({}, function (a, d) {
      R(b, d, a);
    });
  }

  function Ie(a, b) {
    var c = Math.min(a.g.length, 1E3),
        d = a.f ? r(a.f.ab, a.f, a) : null;

    a: for (var e = a.g, f = -1;;) {
      var h = ["count=" + c];
      -1 == f ? 0 < c ? (f = e[0].a, h.push("ofs=" + f)) : f = 0 : h.push("ofs=" + f);

      for (var m = !0, v = 0; v < c; v++) {
        var I = e[v].a,
            X = e[v].b;
        I -= f;
        if (0 > I) f = Math.max(0, e[v].a - 100), m = !1;else try {
          ke(X, h, "req" + I + "_");
        } catch (Mb) {
          d && d(X);
        }
      }

      if (m) {
        d = h.join("&");
        break a;
      }
    }

    a = a.g.splice(0, c);
    b.u = a;
    return d;
  }

  function Ke(a) {
    if (!a.b && !a.l) {
      a.T = 1;
      var b = a.Pa;
      Tb || Ub();
      Wb || (Tb(), Wb = !0);
      Pb.add(b, a);
      a.B = 0;
    }
  }

  function Le(a) {
    if (a.b || a.l) return J(a.a, "Request already in progress"), !1;
    if (3 <= a.B) return !1;
    H(a.a, "Going to retry GET");
    a.T++;
    a.l = Ec(r(a.Pa, a), He(a, a.B));
    a.B++;
    return !0;
  }

  g.Pa = function () {
    this.l = null;
    H(this.a, "Creating new HttpRequest");
    this.b = new L(this, this.a, "rpc", this.T);
    null === this.h && (this.b.j = this.i);
    this.b.N = 0;
    var a = M(this.ua);
    R(a, "RID", "rpc");
    R(a, "SID", this.J);
    R(a, "CI", this.ka ? "0" : "1");
    R(a, "AID", this.N);
    Be(this, a);
    R(a, "TYPE", "xmlhttp");
    this.h && this.i && xe(a, this.h, this.i);
    this.G && this.b.setTimeout(this.G);
    Yc(this.b, a, !0, this.X);
    H(this.a, "New Request created");
  };

  function Td(a, b, c) {
    H(a.a, "Test Connection Finished");
    var d = b.l;
    d && be(a.c, d);
    a.ka = c;
    a.u = b.f;
    H(a.a, "connectChannel_()");
    a.D = Me(a, a.ja);
    Fe(a);
  }

  function Vd(a, b) {
    H(a.a, "Test Connection Failed");
    a.u = b.f;
    V(a, 2);
  }

  g.Oa = function (a, b) {
    if (0 != this.F && (this.b == a || ee(this.c, a))) if (this.u = a.C, !a.v && ee(this.c, a) && 3 == this.F) {
      try {
        var c = this.la.a.parse(b);
      } catch (f) {
        c = null;
      }

      if (p(c) && 3 == c.length) {
        if (b = c, 0 == b[0]) {
          a: if (H(this.a, "Server claims our backchannel is missing."), this.l) H(this.a, "But we are currently starting the request.");else {
            if (this.b) {
              if (this.b.D + 3E3 < a.D) De(this), this.b.cancel(), this.b = null;else break a;
            } else D(this.a.a, "We do not have a BackChannel established");
            Le(this);
            K(18);
          }
        } else this.xa = b[1], a = this.xa - this.N, 0 < a && (b = b[2], H(this.a, b + " bytes (in " + a + " arrays) are outstanding on the BackChannel"), 37500 > b && this.ka && 0 == this.B && !this.s && (this.s = Ec(r(this.ib, this), 6E3)));
      } else H(this.a, "Bad POST response data returned"), V(this, 11);
    } else if ((a.v || this.b == a) && De(this), !xa(b)) for (b = c = this.la.a.parse(b), c = 0; c < b.length; c++) {
      var d = b[c];
      this.N = d[0];
      d = d[1];
      if (2 == this.F) {
        if ("c" == d[0]) {
          this.J = d[1];
          this.X = d[2];
          var e = d[3];
          null != e && (this.na = e, F(this.a, "VER=" + this.na));
          e = d[4];
          null != e && (this.ya = e, F(this.a, "SVER=" + this.ya));
          d = d[5];
          null != d && "number" == typeof d && 0 < d && (this.G = d *= 1.5, F(this.a, "backChannelRequestTimeoutMs_=" + d));
          this.o && (d = a.a) && ((e = id(d, "X-Client-Wire-Protocol")) && be(this.c, e), this.j && ((d = id(d, "X-HTTP-Session-Id")) ? (this.K = d, R(this.D, this.j, d)) : D(this.a.a, "Missing X_HTTP_SESSION_ID in the handshake response")));
          this.F = 3;
          this.f && this.f.Da();
          d = a;
          this.ua = Ud(this, this.X, this.ja);
          d.v ? (H(this.a, "Upgrade the handshake request to a backchannel."), fe(this.c, d), (e = this.G) && d.setTimeout(e), d.s && (bd(d), Zc(d)), this.b = d) : Ke(this);
        } else "stop" != d[0] && "close" != d[0] || V(this, 7);
      } else 3 == this.F && ("stop" == d[0] || "close" == d[0] ? "stop" == d[0] ? V(this, 7) : ze(this) : "noop" != d[0] && this.f && this.f.Ca(d), this.B = 0);
    }
  };

  g.ib = function () {
    null != this.s && (this.s = null, this.b.cancel(), this.b = null, Le(this), K(19));
  };

  function De(a) {
    null != a.s && (k.clearTimeout(a.s), a.s = null);
  }

  g.ta = function (a) {
    H(this.a, "Request complete");
    var b = null;

    if (this.b == a) {
      De(this);
      this.b = null;
      var c = 2;
    } else if (ee(this.c, a)) b = a.u, fe(this.c, a), c = 1;else return;

    this.u = a.C;
    if (0 != this.F) if (a.f) 1 == c ? (Dc(a.l ? a.l.length : 0, t() - a.D, this.v), Fe(this)) : Ke(this);else {
      var d = a.m;
      if (3 == d || 0 == d && 0 < this.u) H(this.a, "Not retrying due to error type");else {
        var e = this;
        H(this.a, function () {
          return "Maybe retrying, last error: " + Sc(d, e.u);
        });
        if (1 == c && Ge(this, a) || 2 == c && Le(this)) return;
        H(this.a, "Exceeded max number of retries");
      }
      b && 0 < b.length && he(this.c, b);
      H(this.a, "Error: HTTP request failed");

      switch (d) {
        case 1:
          V(this, 5);
          break;

        case 4:
          V(this, 10);
          break;

        case 3:
          V(this, 6);
          break;

        default:
          V(this, 2);
      }
    }
  };

  function He(a, b) {
    var c = a.Wa + Math.floor(Math.random() * a.$a);
    a.qa() || (H(a.a, "Inactive channel"), c *= 2);
    return c * b;
  }

  function V(a, b) {
    F(a.a, "Error code " + b);

    if (2 == b) {
      var c = null;
      a.f && (c = null);
      var d = r(a.pb, a);
      c || (c = new Q("//www.google.com/images/cleardot.gif"), k.location && "http" == k.location.protocol || sd(c, "https"), Wc(c));
      le(c.toString(), d);
    } else K(2);

    H(a.a, "HttpChannel: error - " + b);
    a.F = 0;
    a.f && a.f.Ba(b);
    Ce(a);
    Ae(a);
  }

  g.pb = function (a) {
    a ? (F(this.a, "Successfully pinged google.com"), K(2)) : (F(this.a, "Failed to ping google.com"), K(1));
  };

  function Ce(a) {
    a.F = 0;
    a.u = -1;

    if (a.f) {
      var b = ge(a.c);
      if (0 != b.length || 0 != a.g.length) H(a.a, function () {
        return "Number of undelivered maps, pending: " + b.length + ", outgoing: " + a.g.length;
      }), a.c.c.length = 0, wa(a.g), a.g.length = 0;
      a.f.Aa();
    }
  }

  function Me(a, b) {
    b = Ne(a, null, b);
    H(a.a, "GetForwardChannelUri: " + b);
    return b;
  }

  function Ud(a, b, c) {
    b = Ne(a, a.ia() ? b : null, c);
    H(a.a, "GetBackChannelUri: " + b);
    return b;
  }

  function Ne(a, b, c) {
    var d = Hd(c);
    if ("" != d.b) b && td(d, b + "." + d.b), ud(d, d.i);else {
      var e = k.location,
          f;
      b ? f = b + "." + e.hostname : f = e.hostname;
      d = Id(e.protocol, f, e.port, c);
    }
    a.U && Ca(a.U, function (a, b) {
      R(d, b, a);
    });
    b = a.j;
    c = a.K;
    b && c && R(d, b, c);
    R(d, "VER", a.na);
    Be(a, d);
    return d;
  }

  g.ca = function (a) {
    if (a && !this.S) throw Error("Can't create secondary domain capable XhrIo object.");
    a = new T(this.Ta);
    a.o = this.S;
    return a;
  };

  g.qa = function () {
    return !!this.f && !0;
  };

  g.ia = function () {
    return this.S;
  };

  new Qd();

  function Oe() {}

  g = Oe.prototype;

  g.Da = function () {};

  g.Ca = function () {};

  g.Ba = function () {};

  g.Aa = function () {};

  g.ab = function () {};

  function Pe(a) {
    for (var b = arguments[0], c = 1; c < arguments.length; c++) {
      var d = arguments[c];
      if (0 == d.lastIndexOf("/", 0)) b = d;else {
        var e;
        (e = "" == b) || (e = b.length - 1, e = 0 <= e && b.indexOf("/", e) == e);
        e ? b += d : b += "/" + d;
      }
    }

    return b;
  }

  ;

  function Qe() {
    if (z && !(10 <= Number(Wa))) throw Error("Environmental error: no available transport.");
  }

  Qe.prototype.a = function (a, b) {
    return new W(a, b);
  };

  function W(a, b) {
    B.call(this);
    this.a = new ye(b);
    this.b = a;
    this.o = b && b.testUrl ? b.testUrl : Pe(this.b, "test");
    this.c = qc("goog.labs.net.webChannel.WebChannelBaseTransport");
    this.g = b && b.messageUrlParams || null;
    a = b && b.messageHeaders || null;
    b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = {
      "X-Client-Protocol": "webchannel"
    });
    this.a.i = a;
    a = b && b.initMessageHeaders || null;
    b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = {
      "X-WebChannel-Content-Type": b.messageContentType
    });
    b && b.Ea && (a ? a["X-WebChannel-Client-Profile"] = b.Ea : a = {
      "X-WebChannel-Client-Profile": b.Ea
    });
    this.a.L = a;
    (a = b && b.httpHeadersOverwriteParam) && !xa(a) && (this.a.h = a);
    this.l = b && b.supportsCrossDomainXhr || !1;
    this.j = b && b.sendRawJson || !1;
    (b = b && b.httpSessionIdParam) && !xa(b) && (this.a.j = b, a = this.g, null !== a && b in a && (a = this.g, b in a && delete a[b], D(this.c, "Ignore httpSessionIdParam also specified with messageUrlParams: " + b)));
    this.h = new Re(this);
  }

  u(W, B);
  g = W.prototype;

  g.addEventListener = function (a, b, c, d) {
    W.H.addEventListener.call(this, a, b, c, d);
  };

  g.removeEventListener = function (a, b, c, d) {
    W.H.removeEventListener.call(this, a, b, c, d);
  };

  g.fb = function () {
    this.a.f = this.h;
    this.l && (this.a.S = !0);
    var a = this.a,
        b = this.o,
        c = this.b,
        d = this.g || void 0;
    H(a.a, "connect()");
    K(0);
    a.ja = c;
    a.U = d || {};
    a.o && (H(a.a, "connect() bypassed channel-test."), a.I.b = [], a.I.a = !1);
    H(a.a, "connectTest_()");
    a.C = new Rd(a, a.a);
    null === a.h && (a.C.i = a.i);
    c = b;
    a.h && a.i && (c = xe(b, a.h, a.i));
    a = a.C;
    a.m = c;
    b = Me(a.a, a.m);
    K(3);
    c = a.a.I.b;
    null != c ? (a.g = c[0], a.P = 1, Sd(a)) : ($c(b, "MODE", "init"), !a.a.o && a.a.j && $c(b, "X-HTTP-Session-Id", a.a.j), a.c = new L(a, a.b, void 0, void 0), a.c.j = a.i, Yc(a.c, b, !1, null), a.P = 0);
  };

  g.close = function () {
    ze(this.a);
  };

  g.gb = function (a) {
    if (l(a)) {
      var b = {};
      b.__data__ = a;
      Ee(this.a, b);
    } else this.j ? (b = {}, b.__data__ = Db(a), Ee(this.a, b)) : Ee(this.a, a);
  };

  g.w = function () {
    this.a.f = null;
    delete this.h;
    ze(this.a);
    delete this.a;
    W.H.w.call(this);
  };

  function Se(a) {
    Mc.call(this);
    var b = a.__sm__;

    if (b) {
      a: {
        for (var c in b) {
          a = c;
          break a;
        }

        a = void 0;
      }

      (this.c = a) ? (a = this.c, this.data = null !== b && a in b ? b[a] : void 0) : this.data = b;
    } else this.data = a;
  }

  u(Se, Mc);

  function Te() {
    Nc.call(this);
    this.status = 1;
  }

  u(Te, Nc);

  function Re(a) {
    this.a = a;
  }

  u(Re, Oe);

  Re.prototype.Da = function () {
    rc(this.a.c, "WebChannel opened on " + this.a.b);
    this.a.dispatchEvent("a");
  };

  Re.prototype.Ca = function (a) {
    this.a.dispatchEvent(new Se(a));
  };

  Re.prototype.Ba = function (a) {
    rc(this.a.c, "WebChannel aborted on " + this.a.b + " due to channel error: " + a);
    this.a.dispatchEvent(new Te(a));
  };

  Re.prototype.Aa = function () {
    rc(this.a.c, "WebChannel closed on " + this.a.b);
    this.a.dispatchEvent("b");
  };

  var Ue = ja(function (a, b) {
    function c() {}

    c.prototype = a.prototype;
    var d = new c();
    a.apply(d, Array.prototype.slice.call(arguments, 1));
    return d;
  }, Qe);

  function Ve() {
    this.b = [];
    this.a = [];
  }

  function We(a) {
    0 == a.b.length && (a.b = a.a, a.b.reverse(), a.a = []);
    return a.b.pop();
  }

  function Xe(a) {
    return a.b.length + a.a.length;
  }

  Ve.prototype.A = function () {
    for (var a = [], b = this.b.length - 1; 0 <= b; --b) {
      a.push(this.b[b]);
    }

    var c = this.a.length;

    for (b = 0; b < c; ++b) {
      a.push(this.a[b]);
    }

    return a;
  };

  function Ye(a, b) {
    w.call(this);
    this.h = a || 0;
    this.c = b || 10;
    if (this.h > this.c) throw Error(Ze);
    this.a = new Ve();
    this.b = new Xd();
    this.g = null;
    this.aa();
  }

  u(Ye, w);
  var Ze = "[goog.structs.Pool] Min can not be greater than max";
  g = Ye.prototype;

  g.da = function () {
    var a = t();

    if (!(null != this.g && 0 > a - this.g)) {
      for (var b; 0 < Xe(this.a) && (b = We(this.a), !this.sa(b));) {
        this.aa();
      }

      !b && $e(this) < this.c && (b = this.pa());
      b && (this.g = a, this.b.add(b));
      return b;
    }
  };

  g.ob = function (a) {
    return pd(this.b.a, Yd(a)) ? (this.ma(a), !0) : !1;
  };

  g.ma = function (a) {
    pd(this.b.a, Yd(a));
    this.sa(a) && $e(this) < this.c ? this.a.a.push(a) : af(a);
  };

  g.aa = function () {
    for (var a = this.a; $e(this) < this.h;) {
      var b = this.pa();
      a.a.push(b);
    }

    for (; $e(this) > this.c && 0 < Xe(this.a);) {
      af(We(a));
    }
  };

  g.pa = function () {
    return {};
  };

  function af(a) {
    if ("function" == typeof a.$) a.$();else for (var b in a) {
      a[b] = null;
    }
  }

  g.sa = function (a) {
    return "function" == typeof a.bb ? a.bb() : !0;
  };

  function $e(a) {
    return Xe(a.a) + a.b.a.c;
  }

  g.w = function () {
    Ye.H.w.call(this);
    if (0 < this.b.a.c) throw Error("[goog.structs.Pool] Objects not released");
    delete this.b;

    for (var a = this.a; 0 != a.b.length || 0 != a.a.length;) {
      af(We(a));
    }

    delete this.a;
  };

  function bf(a, b) {
    this.a = a;
    this.b = b;
  }

  ;

  function cf(a) {
    this.a = [];
    if (a) a: {
      if (a instanceof cf) {
        var b = a.M();
        a = a.A();

        if (0 >= this.a.length) {
          for (var c = this.a, d = 0; d < b.length; d++) {
            c.push(new bf(b[d], a[d]));
          }

          break a;
        }
      } else b = Ea(a), a = Da(a);

      for (d = 0; d < b.length; d++) {
        df(this, b[d], a[d]);
      }
    }
  }

  function df(a, b, c) {
    var d = a.a;
    d.push(new bf(b, c));
    b = d.length - 1;
    a = a.a;

    for (c = a[b]; 0 < b;) {
      if (d = b - 1 >> 1, a[d].a > c.a) a[b] = a[d], b = d;else break;
    }

    a[b] = c;
  }

  cf.prototype.A = function () {
    for (var a = this.a, b = [], c = a.length, d = 0; d < c; d++) {
      b.push(a[d].b);
    }

    return b;
  };

  cf.prototype.M = function () {
    for (var a = this.a, b = [], c = a.length, d = 0; d < c; d++) {
      b.push(a[d].a);
    }

    return b;
  };

  function ef() {
    cf.call(this);
  }

  u(ef, cf);

  function Y(a, b) {
    this.f = new ef();
    Ye.call(this, a, b);
  }

  u(Y, Ye);
  g = Y.prototype;

  g.da = function (a, b) {
    if (!a) return Y.H.da.call(this);
    df(this.f, void 0 !== b ? b : 100, a);
    this.ra();
  };

  g.ra = function () {
    for (var a = this.f; 0 < a.a.length;) {
      var b = this.da();

      if (b) {
        var c = a,
            d = c.a,
            e = d.length;
        var f = d[0];
        if (0 >= e) f = void 0;else {
          if (1 == e) ua(d);else {
            d[0] = d.pop();
            d = 0;
            c = c.a;
            e = c.length;

            for (var h = c[d]; d < e >> 1;) {
              var m = 2 * d + 1,
                  v = 2 * d + 2;
              m = v < e && c[v].a < c[m].a ? v : m;
              if (c[m].a > h.a) break;
              c[d] = c[m];
              d = m;
            }

            c[d] = h;
          }
          f = f.b;
        }
        f.apply(this, [b]);
      } else break;
    }
  };

  g.ma = function (a) {
    Y.H.ma.call(this, a);
    this.ra();
  };

  g.aa = function () {
    Y.H.aa.call(this);
    this.ra();
  };

  g.w = function () {
    Y.H.w.call(this);
    k.clearTimeout(void 0);
    ua(this.f.a);
    this.f = null;
  };

  function Z(a, b, c, d) {
    this.l = a;
    this.j = !!d;
    Y.call(this, b, c);
  }

  u(Z, Y);

  Z.prototype.pa = function () {
    var a = new T(),
        b = this.l;
    b && b.forEach(function (b, d) {
      a.headers.set(d, b);
    });
    this.j && (a.o = !0);
    return a;
  };

  Z.prototype.sa = function (a) {
    return !a.i && !a.a;
  };

  Qe.prototype.createWebChannel = Qe.prototype.a;
  W.prototype.send = W.prototype.gb;
  W.prototype.open = W.prototype.fb;
  W.prototype.close = W.prototype.close;
  Fc.NO_ERROR = 0;
  Fc.TIMEOUT = 8;
  Fc.HTTP_ERROR = 6;
  Gc.COMPLETE = "complete";
  Kc.EventType = Lc;
  Lc.OPEN = "a";
  Lc.CLOSE = "b";
  Lc.ERROR = "c";
  Lc.MESSAGE = "d";
  B.prototype.listen = B.prototype.Ia;
  Z.prototype.getObject = Z.prototype.da;
  Z.prototype.releaseObject = Z.prototype.ob;
  T.prototype.listenOnce = T.prototype.Ja;
  T.prototype.getLastError = T.prototype.hb;
  T.prototype.getLastErrorCode = T.prototype.Ga;
  T.prototype.getStatus = T.prototype.W;
  T.prototype.getStatusText = T.prototype.Ha;
  T.prototype.getResponseJson = T.prototype.eb;
  T.prototype.getResponseText = T.prototype.V;
  T.prototype.getResponseText = T.prototype.V;
  T.prototype.send = T.prototype.fa;
  module.exports = {
    createWebChannelTransport: Ue,
    ErrorCode: Fc,
    EventType: Gc,
    WebChannel: Kc,
    XhrIoPool: Z
  };
}).call(typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});